import { TUTORING_LEAD_SOURCES } from "@seneca/tutoring-service-consts";

import { ROUTES } from "routing/routes";

import { linkToParentDashboard } from "../../links";

export const OneToOneTutoringSourceParamKey = "oneToOneTutoringSource";

export function linkToTutoringPage(source?: TUTORING_LEAD_SOURCES) {
  return ROUTES.PARENT.TUTORING.buildPath(
    {},
    { oneToOneTutoringSource: source }
  );
}
